import React, { useEffect, useState } from "react";
import { HiShoppingBag } from "react-icons/hi";
import { BsPersonCircle } from "react-icons/bs";
import { CgSupport } from "react-icons/cg";
import OrderTableMobile from "../OrderTable/OrderTableMobile";
import ProfileMobile from "../MyProfile/ProfileMobile";
import orderServiceInstance from "../../../APIs/order";
import { useAuth } from "../../AuthContext/AuthContext";
import { Order } from "../MyOrders/MyOrders";

const MobileTabs: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>("1");
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { user } = useAuth();

  useEffect(() => {
    const fetchOrders = async () => {
      if (!user?.id) {
        console.warn("User ID is not defined.");
        return;
      }

      try {
        const result = await orderServiceInstance.getOrderByUserId(user.id);
        if (result.data) {
          setOrders(result.data || []);
        } else {
   
        }
      } catch (err) {
        setError(JSON.stringify(err));
      }
      setLoading(false);
    };

    fetchOrders();
  }, [user?.id]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case "1":
        return (
          <div>
            <OrderTableMobile orders={orders} />
          </div>
        );
      case "2":
        // Support tab: now a link that opens in a new tab
        return (
          <div>
            <a
              href="https://example.com/support" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-blue-500"
            >
              Go to Support
            </a>
          </div>
        );
      case "3":
        // Profile tab: renders the ProfileMobile component
        return <div><ProfileMobile /></div>;
      default:
        return <div>My Orders Content</div>;
    }
  };

  return (
    <div className="lg:hidden mt-[30%]">
      {/* Tabs */}
      <div className="tabs flex justify-around bg-[#75A7AD] p-4 rounded-lg shadow-lg">
        <div
          onClick={() => setActiveTab("1")}
          className={`tab ${
            activeTab === "1" ? "bg-white text-[#75A7AD]" : "text-white"
          } p-2 rounded-lg cursor-pointer flex items-center space-x-2`}>
          <HiShoppingBag size={20} />
          <span>My Orders</span>
        </div>
        <div
          onClick={() => setActiveTab("2")}
          className={`tab ${
            activeTab === "2" ? "bg-white text-[#75A7AD]" : "text-white"
          } p-2 rounded-lg cursor-pointer flex items-center space-x-2`}>
          <CgSupport size={20} />
          <span>Support</span>
        </div>
        <div
          onClick={() => setActiveTab("3")}
          className={`tab ${
            activeTab === "3" ? "bg-white text-[#75A7AD]" : "text-white"
          } p-2 rounded-lg cursor-pointer flex items-center space-x-2`}>
          <BsPersonCircle size={20} />
          <span>My Personal Details</span>
        </div>
      </div>

      <div className="tab-content p-4 mt-4 bg-white rounded-lg shadow-lg">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default MobileTabs;

